import { render, staticRenderFns } from "./ViewDiagnose.vue?vue&type=template&id=1d663249&scoped=true"
import script from "./ViewDiagnose.vue?vue&type=script&lang=js"
export * from "./ViewDiagnose.vue?vue&type=script&lang=js"
import style0 from "./ViewDiagnose.vue?vue&type=style&index=0&id=1d663249&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d663249",
  null
  
)

export default component.exports